import { useEffect, useState } from "react";
import MinimalArrow from "../components/MinimalArrow";
import technologies from '../assets/json/tecnology.json';
import tecnologie1 from '../assets/tecnologie/C1737T01.jpg';
import quadricipideImage from '../assets/tecnologie/the-procedure-of-myo.jpg';
import tecnologie2 from '../assets/tecnologie/C1740T01.jpg';
import tecnologie3 from '../assets/tecnologie/C1743T01.jpg';
import laserTecno from '../assets/tecnologie/C1784T01.jpg';
import schermo from '../assets/tecnologie/C1795T01.jpg';
import polpaccio from '../assets/tecnologie/C1854T01.jpg';
import tecnologie4 from '../assets/tecnologie/C1856T01.jpg';
import tecnologie5 from '../assets/tecnologie/C1861T01.jpg';
import tecnologie6 from '../assets/tecnologie/C1867T01.jpg';
import tecnologie7 from '../assets/tecnologie/C1869T01.jpg';
import ContactForm from "../components/contactForm/ContactForm";



export default function Tecnologie() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fadeOut, setFadeOut] = useState(false);

    const imgTecnologie = [tecnologie1, quadricipideImage, tecnologie2, tecnologie3, laserTecno, schermo, polpaccio, tecnologie4, tecnologie5, tecnologie6, tecnologie7]

    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])

    useEffect(() => {
      const interval = setInterval(() => {
        setFadeOut(true); // Start fading out the current image
        setTimeout(() => {
          setCurrentIndex((prevIndex) => (prevIndex + 1) % imgTecnologie.length); // Change image
          setFadeOut(false); // Start fading in the new image
        }, 1000); // 1-second timeout for fade-out effect
      }, 5000); // Change every 5 seconds
  
      return () => clearInterval(interval); // Cleanup the interval on component unmount
    }, [imgTecnologie.length]);


return <>
    <MinimalArrow 
        title={'Le nostre tecnologie'}
        subtitle={"Presso il nostro centro di fisioterapia, abbracciamo l'innovazione utilizzando le più recenti tecnologie per garantire ai nostri pazienti esperienze di riabilitazione avanzate e personalizzate."}
        backgroundImage={quadricipideImage}
    />
    <div className="flex bg-black">
        <div className="w-2/5 h-screen sticky top-0 overflow-hidden hidden md:block">
            <img src={imgTecnologie[currentIndex]}  alt="" className={`object-cover w-full h-full transition-opacity duration-1000 ease-in-out ${
            fadeOut ? 'opacity-0' : 'opacity-100'
            }`} />
        </div>
        <div className="md:w-3/5 w-full relative flex flex-col items-center overflow-auto">
            <h2 className="text-4xl text-white font-semibold pt-12 text-mcare  panoragraf-light">Tecnologie</h2>
            <div className="w-full h-full inset-0 ">
                <div className="relative text-white h-full pt-16 text-center flex flex-col items-center bg-black">
                    <ul className='text-left mb-8 w-full max-w-2xl px-5'>
                        {technologies.map((technology, index) =>
                            <li key={index} className="mb-5 pb-3  mt-8">
                                <span className="text-xl"><b>{technology.name}:</b></span> 
                                <p className="pt-3">{technology.description}</p>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    </div>
    {/* sez. convenzioni */}
    <div className="grid grid-cols-4 gap-0" id='formContatti'>
        <div className="col-span-4 flex justify-center items-center py-32 bg-black">
            <div className="w-full absolute z-0" style={{"height":"120%"}}></div>
                <div className='w-full lg:w-2/6 z-30 px-5'>
                    <p className='text-center text-4xl font-semibold text-mcare panoragraf-light'>Prenota una visita</p>
                    <ContactForm 
                    LandingName='mcare'
                    Name={true}
                    NameClass='text-white'
                    NameText='Nome e Cognome:'
                    NameRequired={true}
                    Tel={true}
                    TelClass='text-white'
                    TelText='Telefono:'
                    TelRequired={true}
                    Email={true}
                    EmailClass='text-white'
                    EmailText='Email:'
                    EmailRequired={true}
                    ConsensoDati={true}
                    ConsensoDatiRequired={true}
                    ConsensoDatiText='Consenso dati'
                    ConsensoDatiID={1}
                    ConsensoDatiClass='text-white'
                    successText='Messaggio inviato con successo!'  
                    successLink='/'
                    errorText='Si è verificato un errore, Riprova!'
                    SendText='Invia'
                    SendClass='progress-button-mcare w-full'
                    borderType="border bg-[#65806e69]"
                    />
                </div>
            </div>
        </div>
</>
}